gz-text[class='patch-scan-text'] {
  overflow: hidden;
}
